import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import CountriesListView from "./countries-list.html";
import CountriesEditView from "./countries-edit.html";
import CountriesRegionsEditView from "./countries_regions-edit.html";


angular.module("countries", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('countries', {
                url: "/countries",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })
            .state('countries.list', {
                url: "/list",
                controller: "CountriesListCtrl",
                template: CountriesListView,
                data: { pageTitle: 'Países' }
            })
            .state('countries.edit', {
                url: "/edit/:id",
                controller: "CountriesEditCtrl",
                template: CountriesEditView,
                data: { pageTitle: 'Países' }
            })
            .state('countries.regions_edit', {
                url: "/edit/regions/:id",
                controller: "CountriesRegionsEditCtrl",
                template: CountriesRegionsEditView,
                params: {
                    'id': "",
                    'parent_id': "",
                },
                data: { pageTitle: 'Regiones' }
            });
    }])
;